<template>
    <div class="pa-0 container">
        <v-row style="height: 100%">
            <v-col class="text-center d-inline-flex justify-center align-center" cols="12">
                <v-card min-width="40%">
                    <v-card-text v-if="verify">
                        <h2 class="primary--text pt-6 pb-3 pa-0">Recuperar contraseña</h2>
                        <form class="">
                            <v-text-field
                                v-model="password"
                                label="Contraseña"
                                type="password"
                                outlined
                                :rules="[rules.required]"
                                class="pa-0"
                            ></v-text-field>
                            <v-text-field
                                v-model="repeat_password"
                                label="Repetir contraseña"
                                type="password"
                                outlined
                                :rules="[rules.required, rules.valid]"
                                class="pb-3"
                            ></v-text-field>
                            <v-btn 
                                color="accent" 
                                block
                                class="mt-7 mb-3"
                                :disabled="!confirmEnable"
                                @click="doChange"
                                >Cambiar contraseña</v-btn
                            >
                        </form>
                    </v-card-text>
                    <v-card-text v-else>
                        <h2 class="primary--text pt-6 pb-3 pa-0">Este enlace ha expirado</h2>
                        <p>El enlace es invalido. Esto puede pasar porque ha expirado o ya ha sido usado</p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { auth } from '../plugins/firebase'

export default {
    name: 'Login',
    computed: {
        confirmEnable(){
            if(!this.password || !this.repeat_password) return false
            if(this.password !== this.repeat_password) return false
            return true
        }
    },
    data() {
        return {
            password: null,
            repeat_password: null,
            verify: true,
            rules: {
                required: value => !!value || 'Complete los campos',
                valid: v => this.password === this.repeat_password || 'Las contraseñas no coinciden'
            }
        }
    },
    methods: {
        async doChange(){
            try {
                const { oobCode } = this.$route.query
                await auth.confirmPasswordReset(oobCode, this.password)
                this.$router.push({ name: 'Login' })
            } catch (error) {
                console.log(error)
            }
        }
    },
    async mounted() {
        const { oobCode, mode } = this.$route.query
        if( !oobCode || !mode ) return this.verify = false
        if( mode != 'resetPassword' ) return this.verify = false
        
        try {
            const ver = await auth.verifyPasswordResetCode(oobCode)
            this.verify = true
        } catch (error) {
            if(error.code === 'auth/invalid-action-code')
                this.verify = false
        }
    },
}
</script>

<style scoped>
    .container{
        height: 100%;
        background-color: var(--v-primary-base);
    }
</style>